import { createMatchingLookupField } from './MatchingLookupField';

export const QuoteNumberField = createMatchingLookupField({
    lookupType: 'OfferMatchingLookupType',
    primaryKey: 'offerNumber',
});

export const QuoteNumberFieldConditionalComponents = [
    {
        condition: ({ fieldName }) => fieldName === 'quote_number',
        component: QuoteNumberField,
    },
];
